<template>
  <div>
    <div v-if="detail === null" style="min-height: 100vh;"></div>
    <div v-else class="symposium_video_detail">
      <div class="symposium_video_detail-top">
        <div ref="topBackground" class="symposium_video_detail-background"></div>
        <div class="container">
          <router-link to="/symposium/video">
            <div class="symposium_video_detail-back">
              <img src="@/assets/icons/arrow-left-white.svg" alt="Arrow left white"
                class="symposium_video_detail-back-icon" />
              <span style="margin-top: 2px;">Back to all stage</span>
            </div>
          </router-link>
          <h1 class="symposium_video_detail-name">
            {{ detail.room[0].name }}
          </h1>
          <p class="symposium_video_detail-sub_title">
            : {{ detail.name }}
          </p>
          <div ref="topVideoEmbed" class="symposium_video_detail-video_embed">
            <div v-html="detail.video_embed"></div>
          </div>
        </div>
      </div>
      <div class="symposium_video_detail-content">
        <div class="container">
          <div v-if="detail.content">
            <h2 class="symposium_video_detail-heading_2">Synopsis :</h2>
            <div v-html="detail.content" class="symposium_video_detail-description"></div>
          </div>
          <h2 class="symposium_video_detail-heading_2">Speaker :</h2>
          <div class="row row-eq-height">
            <div class="speaker" v-html="detail.speakers"></div>
            <div v-for="(speaker, index) in detail.photo" :key="index" class="col-12 col-md-6 col-lg-4"
              style="margin-bottom: 30px;">
              <div :class="[
                'symposium_video_detail-speaker',
                classOfProfile,
              ]">
                <img v-lazy="`${baseURL}/storage/app/img/talkdetailphoto/${speaker.profile_image}`" :alt="speaker.name"
                  class="symposium_video_detail-speaker-profile" />
                <div class="symposium_video_detail-speaker-content">
                  <p style="margin-bottom: 8px; font-size: 1rem;">{{ speaker.name }}</p>
                  <p style="font-weight: 400; font-size: 0.875rem;">
                    {{ speaker.position }}<br v-if="speaker.position" />
                    {{ speaker.company }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="detail.previous || detail.next" class="symposium_video_detail-pan" :style="{
            justifyContent: detail.previous ? '' : 'center',
          }">
            <router-link v-if="detail.previous" :to="`/symposium/video/${detail.previous.id}`"
              class="symposium_video_detail-pan-box">
              <div class="symposium_video_detail-pan-cover">
                <img v-lazy="`${baseURL}/storage/app/img/symposium/${detail.previous.video_thumbnail}`"
                  :alt="detail.previous.name">
                <div class="symposium_video_detail-pan-red_bg"></div>
                <div class="symposium_video_detail-pan-content">
                  <p class="symposium_video_detail-pan-title">
                    {{ detail.previous.name }}
                  </p>
                </div>
              </div>
              <div class="symposium_video_detail-pan-m">
                {{ detail.previous.name }}
              </div>
              <div class="symposium_video_detail-pan-label">
                <img src="@/assets/icons/arrow-left-black.svg" alt="Arrow left black"
                  class="symposium_video_detail-pan-arrow_l-p" />
                Previous video
              </div>
            </router-link>
            <router-link v-if="detail.next" :to="`/symposium/video/${detail.next.id}`"
              class="symposium_video_detail-pan-box">
              <div class="symposium_video_detail-pan-cover">
                <img v-lazy="`${baseURL}/storage/app/img/symposium/${detail.next.video_thumbnail}`"
                  :alt="detail.next.name">
                <div class="symposium_video_detail-pan-red_bg"></div>
                <div class="symposium_video_detail-pan-content">
                  <p class="symposium_video_detail-pan-title">
                    {{ detail.next.name }}
                  </p>
                </div>
              </div>
              <div class="symposium_video_detail-pan-m">
                {{ detail.next.name }}
              </div>
              <div class="symposium_video_detail-pan-label">
                Next video
                <img src="@/assets/icons/arrow-left-black.svg" alt="Arrow left black"
                  class="symposium_video_detail-pan-arrow_l-n" />
              </div>
            </router-link>
          </div>
        </div>
        <div class="symposium_video_detail-sponsor-wrapper">
          <div class="symposium_video_detail-sponsor-bg"></div>
          <div class="container">
            <img v-lazy="require('@/assets/images/symposium/sponsor.png')" alt="Symposium video detail sponsor"
              class="symposium_video_detail-sponsor" />
          </div>
        </div>
        <!-- <div class="sponsor-wapper">
          <Sponsor />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'

export default {
  components: {
    Sponsor: () => import('@/components/Sponsor/Main')
  },
  computed: {
    ...constantsComputed,

    ...mapState({
      detail: state => state.symposium.symposiumDetail
    }),

    classOfProfile() {
      if (this.detail === null) {
        return ''
      }

      const prefixClassName = 'symposium_video_detail-speaker'

      switch (this.detail.room[0].name.toUpperCase()) {
        case 'IGNITE STAGE':
          return `${prefixClassName}--yellow`
        case 'SPARK STAGE':
          return `${prefixClassName}--orange`
        case 'GRAND STAGE':
          return `${prefixClassName}--red`
        default:
          return ''
      }
    }
  },

  methods: {
    setHeightOfBackgroundTop() {
      if (this.detail !== null) {
        const starter = () => {
          const topVideoEmbed = this.$refs.topVideoEmbed
          const topBackground = this.$refs.topBackground

          if (topVideoEmbed && topBackground) {
            window.addEventListener('resize', () => {
              topBackground.style.height = `calc(100% - ${topVideoEmbed.offsetHeight / 2}px)`
            })

            topBackground.style.height = `calc(100% - ${topVideoEmbed.offsetHeight / 2}px)`

            clearInterval(loopForFindElement)
          }
        }

        const loopForFindElement = setInterval(starter, 10)
      }
    }
  },

  watch: {
    'detail'() {
      this.setHeightOfBackgroundTop()
    },

    '$route'() {
      this.$store.dispatch('symposium/defaultDetail')
      this.$store.dispatch('symposium/getDetailById', this.$route.params.id)
    }
  },

  created() {
    sessionStorage.removeItem('symposium_redirect_video_detail_id')

    this.$store.dispatch('symposium/getDetailById', this.$route.params.id)
  },

  beforeDestroy() {
    this.$store.dispatch('symposium/defaultDetail')
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.symposium_video_detail {
  min-height: 100vh;

  &-top {
    position: relative;
    padding-top: 22px;
    width: 100%;
    height: auto;
  }

  &-background {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    // height: calc((100% - 28.125%) - 22px);
    height: 100%;
    background: linear-gradient(131.25deg,
        #000000 41.41%,
        #000000 47.91%,
        #830202 104.59%,
        rgba(255, 0, 0, 0) 115.91%,
        #FF0303 115.91%);
  }

  &-back {
    display: flex;
    align-items: center;
    margin-bottom: 60px;
    font-weight: 700;
    font-size: 1.125rem;
    color: #ffffff;

    &-icon {
      margin-right: 16px;
      width: auto;
      height: 20px;
    }
  }

  &-name {
    margin-bottom: 12px;
    font-weight: 700;
    font-size: 2.25rem;
    color: #ffffff;
  }

  &-sub_title {
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 2.25rem;
    color: #ffffff;
  }

  &-video_embed {
    position: relative;
    padding-bottom: 56.25%;
    width: 100%;
    height: 0;
    // background-color: #EDEDED;
    // box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.25);

    ::v-deep iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &-content {
    margin-top: 60px;
  }

  &-heading_2 {
    margin-bottom: 8px;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 28px;
    color: #000000;
    font-family: var(--h6-font-family, "DB HelvethaicaMon X");
  }

  &-description {
    margin-bottom: 16px;
    font-weight: 400;
    color: #000000;
    font-family: var(--label-font-family, Sarabun);
    font-size: 16px;
  }

  &-speaker {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px;
    height: max-content;
    border-radius: 4px;
    background-color: #EDEDED;

    &-profile {
      width: 70px;
      height: 70px;
      border-radius: 2px;
      background-color: #EDEDED;
    }

    &-content {
      width: calc(100% - 82px);
      line-height: 0.875rem;
      font-weight: 700;
    }

    &--yellow {
      background-color: #FBE180;
    }

    &--orange {
      background-color: #F5AB71;
    }

    &--red {
      background-color: #EF7A66;
    }
  }

  &-pan {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
    margin-bottom: 60px;
    padding-top: 60px;
    border-top: 1px solid #989898;

    @media only screen and (max-width: $break-l) {
      margin-top: 0;
      margin-bottom: 56px;
      padding-top: 30px;
      // border-top: 0;
    }

    &-box {
      width: calc(50% - 10px);

      &:hover,
      &:focus {
        .symposium_video_detail-pan {
          &-red_bg {
            opacity: 1;
            max-height: 100%;
          }

          &-content {
            max-height: 100%;
            background-color: rgba(0, 0, 0, 0);
          }

          &-label {
            color: #E42200;

            @media only screen and (max-width: $break-l) {
              color: #000000;
            }
          }
        }
      }
    }

    &-cover {
      overflow: hidden;
      position: relative;
      padding-bottom: 47.7707%;
      width: 100%;
      height: 0;
      border-radius: 4px;

      @media only screen and (max-width: $break-l) {
        display: none;
      }

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }

    &-red_bg {
      transition: 400ms ease;
      opacity: 0;
      position: absolute;
      bottom: 0;
      left: 0;
      max-height: 80px;
      width: 100%;
      height: 100%;
      background: linear-gradient(112.21deg,
          rgba(0, 0, 0, 0.4) 20.6%,
          rgba(193, 0, 0, 0.4) 119.74%);
    }

    &-content {
      transition: 400ms ease;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-end;
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 20px 40px;
      max-height: 80px;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
    }

    &-title {
      overflow: hidden;
      display: -webkit-box;
      width: 100%;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      line-height: 100%;
      font-weight: 700;
      font-size: 1.25rem;
      color: #ffffff;
    }

    &-m {
      display: none;

      @media only screen and (max-width: $break-l) {
        overflow: hidden;
        display: -webkit-box;
        padding: 4px 16px;
        border-radius: 4px;
        background-color: #F0F0F0;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        font-weight: 700;
        font-size: 1rem;
      }
    }

    &-label {
      margin-top: 12px;
      margin-bottom: 12px;
      text-transform: uppercase;
      text-align: center;
      font-weight: 700;
      font-size: 1.5rem;
      color: #000000;

      @media only screen and (max-width: $break-l) {
        margin-top: 6px;
        margin-bottom: 6px;
        font-size: 1rem;
      }
    }

    &-arrow_l {
      display: none;
      margin-bottom: 4px;
      width: auto;
      height: 8px;

      @media only screen and (max-width: $break-l) {
        display: inline;
      }

      &-p,
      &-n {
        @extend .symposium_video_detail-pan-arrow_l;
      }

      &-p {
        margin-right: 4px;
      }

      &-n {
        transform: rotate(180deg);
        margin-left: 4px;
      }
    }
  }

  &-sponsor {
    width: 100%;
    max-height: 221px;
    height: auto;

    &-wrapper {
      background: #FFF;
      position: relative;
    }

    &-bg {
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #F0E6DC;
    }
  }
}

.speaker {
  font-family: var(--label-font-family, Sarabun);
  padding: var(--space-00, 0px) var(--space-02, 36px);
  gap: var(--space-04, 16px);
  font-size: 16px;
}
</style>
